module.exports = __webpack_public_path__ + "static/media/mdcirclepurple.9af5ad3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/BusinessCard/mdcirclepurple.jpg
// module id = 230
// module chunks = 0